module.exports = __webpack_public_path__ + "static/media/ga.886a7348.svg";